<template>
  <div class="addition-form">
    <el-form ref="formRef" label-width="150px" inline :model="formData" :rules="rules">
      <el-form-item v-for="(item, index) in rows" :key="index" :label="item.label" :prop="item.prop">
        <div class="addition-form-item">
          <el-select class="conditions" v-model="formData[item.prop].condition">
            <el-option v-for="condition in item.conditions" :key="condition.value" :label="condition.label" :value="condition.value">
            </el-option>
          </el-select>

          <template v-if="formData[item.prop].condition === ADDITION_ENUM.RANGE">
            <el-input v-model="formData[item.prop].value1" clearable style="width: 171px" placeholder="请输入">
              <span slot="append">{{ item.unit }}</span>
            </el-input>
            <span>~</span>
            <el-input v-model="formData[item.prop].value2" clearable style="width: 170px" placeholder="请输入">
              <span slot="append">{{ item.unit }}</span>
            </el-input>
          </template>
          <template v-else>
            <el-select
              style="width: 100%"
              v-if="formData[item.prop].condition === ADDITION_ENUM.EQUAL"
              v-model="formData[item.prop].value1"
            >
              <el-option v-for="c in [{ label: '不限', value: '0' }]" :key="c.value" :label="c.label" :value="c.value"> </el-option>
            </el-select>

            <el-input v-else style="width: 350px" clearable v-model="formData[item.prop].value1" placeholder="请输入">
              <span slot="append">{{ item.unit }}</span>
            </el-input>
          </template>
        </div>
      </el-form-item>
    </el-form>
    <div class="btn">
      <slot name="clear"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ADDITION_ENUM } from './detail.data.js'
// eslint-disable-next-line
const props = defineProps({
  rows: {
    type: Array,
    default: () => []
  },
  formData: {
    required: true,
    type: Object
  }
})
const formRef = ref(null)
const rules = {}
const threeDigit = /^[0-9]+([.]{1}[0-9]{1,3})?$/

for (const item of props.rows) {
  // 可以不填，但如果输入值必须是正数，最多小数点3位
  rules[item.prop] = [
    {
      validator(rule, value, callback) {
        let { condition, value1, value2 } = value
        value1 = value1.trim()
        value2 = value2.trim()

        if (value1 > 999999999 || value2 > 999999999) {
          return callback(new Error('最大不能超过1,000,000,000'))
        }

        if (condition === ADDITION_ENUM.RANGE) {
          if (!value1 && !value2) {
            return callback()
          }

          if (Number(value2) < Number(value1)) {
            return callback(new Error('前值应小于后值'))
          }

          if (!threeDigit.test(value1) || !threeDigit.test(value2)) {
            return callback(new Error('请输入正数，最多小数点三位'))
          }

          callback()
        } else {
          if (value1 === '' || threeDigit.test(value1)) {
            callback()
          } else {
            callback(new Error('请输入正数，最多小数点三位'))
          }
        }
      },
      trigger: ['blur', 'input', 'change']
    }
  ]
}

// eslint-disable-next-line
defineExpose({
  validate() {
    return formRef.value.validate()
  },
  getForm() {
    return props.formData
  }
})
</script>

<style scoped lang="scss">
.addition-form {
  .el-form {
    max-height: 460px;
    overflow: auto;
  }

  .btn {
    text-align: right;
  }
}

.addition-form-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 460px;
  .conditions {
    min-width: 100px;
    width: 100px;
    margin-right: 10px;
  }
}
</style>
